export default "__VITE_ASSET__e2e0d8cd__"